//plugin for nubmer input with arrows up/down
"use strict";

$.widget("fotobook.numberInput", {
    buttonUp: null,
    buttonDown: null,
    buttonsWrapper: null,
    "options" : {
        "min" : null,
        "max" : null,
        "step" : 1,
        "timeStart" : 400,
        "timeMin" : 50,
        "timeStep" : 50,
        "changeDelay" : 1000,
    },
    _create: function(){
        this._createLayout();
        this._on({
            "input" : this._input,
            "keypress" : this._keypress,
        });
        this._on(this.buttonUp.add(this.buttonDown), this.mouseDownEvents);
    },

    _createLayout: function(){
        this.buttonsWrapper = $("<div>", {
            "class" : "fotobook-number-buttons",
        });
        this.buttonUp = $("<div>", {
            "class" : "fotobook-number-control up",
        });
        this.buttonDown = $("<div>", {
            "class" : "fotobook-number-control down",
        });
        this.buttonsWrapper.append(this.buttonUp).append(this.buttonDown);
        this.element.after(this.buttonsWrapper);
        this.element.addClass("fotobook-number-input");
    },
    currentValue: function(){
        return parseInt(this.element.val(), 10) || 0;
    },
    validateValue: function(value){
        if (this.options.max !== undefined && value > this.options.max){
            value = this.options.max;
        }
        if (this.options.min !== undefined && value < this.options.min){
            value = this.options.min;
        }
        return value;
    },
    value: function(value){
        if (value === undefined){
            return this.currentValue();
        } else if (!this._changePending()){
            value = this.validateValue(value);
            this.element.val(value);
            this._changeValue = value;
        }
    },
    validate: function(){
        this.element.val(this.validateValue(this.currentValue()));
    },
    _input: function(){
        this.validate();
        this._changeEnqueue();
    },
    _destroy: function(){
        this._changeCommit();
        this.buttonsWrapper.remove();
    },

    timeout: null,
    _clearTimeout: function(){
        if (this.timeout){
            clearTimeout(this.timeout);
        }
        this.timeout = null;
    },
    _increment : function(step, delay){
        var widget = this,
            value = this.currentValue();

        this.element.val(this.validateValue(value + step));
        this._changeEnqueue();

        this.timeout = setTimeout(function(){
            delay = Math.max(delay - widget.options.timeStep, widget.options.timeMin);
            widget._increment(step, delay);
        }, delay);
    },
    mouseDownEvents: {
        "mousedown" : function(event){
            var step = $(event.target).hasClass("down") ? -this.options.step : this.options.step;

            this._increment(step, this.options.timeStart);
        },
        "mouseup" : function(event){
            this._clearTimeout();
        },
    },

    _keypress : function(event){
        var originalEvent = event.originalEvent,
            step = 0;

        if (originalEvent.altKey || originalEvent.ctrlKey || originalEvent.metaKey || originalEvent.shiftKey){
            return;
        }
        if (originalEvent.keyCode === $.ui.keyCode.UP){
            step = this.options.step;
        } else if (originalEvent.keyCode === $.ui.keyCode.DOWN){
            step = -this.options.step;
        } else {
            return;
        }
        this.element.val(this.validateValue(this.currentValue() + step));
        this._changeEnqueue();
    },

    _changeValue: null,
    _changeTimeout: null,
    _changeTimeoutClear: function(){
        if (this._changeTimeout){
            clearTimeout(this._changeTimeout);
        }
        this._changeTimeout = null;
    },
    _changePending: function(){
        return !!this._changeTimeout;
    },
    _changeEnqueue: function(){

        var widget = this,
            value = this.currentValue();

        this._changeTimeoutClear();
        this._trigger("input", null, [value]);
        this._changeTimeout = setTimeout(function(){
            widget._changeCommit();
        }, this.options.changeDelay);
    },
    _changeCommit: function(){
        var value = this.currentValue();

        if (!this._changeTimeout){
            return;
        }
        this._changeTimeoutClear();
        if (this._changeValue != value){
            this._changeValue = value;
            this._trigger("change", null, [value]);
        } else {
            this._trigger("cancel", null, [value]);
        }
    },
});
